module.exports = __webpack_public_path__ + "img/icon_shopping_cart.d154646.svg";